import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7975416e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-info" }
const _hoisted_2 = { class: "header-row" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "info" }
const _hoisted_6 = { class: "name" }
const _hoisted_7 = { class: "phone" }
const _hoisted_8 = { class: "right" }
const _hoisted_9 = { class: "jump-tip" }
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 0,
  class: "header-row"
}
const _hoisted_12 = {
  key: 0,
  class: "is-not-upload"
}
const _hoisted_13 = ["src"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "请上传个人照片验证，审核通过后才可申请实体证和下载电子证。", -1))
const _hoisted_15 = {
  key: 1,
  class: "is-not-upload"
}
const _hoisted_16 = ["src"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "你上传的头像已进入人工审核环节，将在一个工作日内审核完毕，请耐心等待。", -1))
const _hoisted_18 = {
  key: 2,
  class: "is-not-pass"
}
const _hoisted_19 = ["src"]

import { computed, withDefaults } from 'vue'
import type { GetCredentialsListDataItem } from '@/types/my-credentials'
import user from '@/assets/my-credentails/photo-default.svg'
import jumpIcon from '@/assets/my-credentails/jump-icon.svg'
import warningIcon from '@/assets/my-credentails/warnning-tip.svg'
import noPassIcon from '@/assets/my-credentails/no-pass-tip.svg'


import { defineComponent } from 'vue'
const __default__ = defineComponent({
  components: {},
  name: 'header-info',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    status: { default: 0 },
    name: { default: '' },
    phone: { default: '' },
    photo: null,
    notPassReason: { default: '' },
    userCardList: { default: () => [] }
  },
  emits: ["upload"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'upload'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { status: number, name: string, phone: string, photo: string | null, notPassReason: string, userCardList: GetCredentialsListDataItem[] };

const jumpTipTextByStatus: { [index: string]: string } = {
  0: '上传照片',
  1: '重新上传',
  2: '更新照片',
  3: '重新上传',
}

const statusTextByStatus: { [index: string]: string } = {
  0: '未上传',
  1: '审核中',
  2: '已上传',
  3: '审核不通过',
}

const canUploadStatus = [0, 1, 3, 4]


// const photo = computed(()=> {
//   // 根据状态
//   return props.photo? props.photo : user
// })

const phoneText = computed(() => {
  // 根据状态
  return props.phone ? props.phone.substr(0, 3) + '****' + props.phone.substr(7) : ''
})



const jumpTipText = computed(() => {
  // 状态 0 未上传 1 审核中 2 已上传 3 审核不通过
  // return jumpTipTextByStatus[String(props.status)]
  // 只有上传照片的情况 （后台图片被重置或者用）
  return jumpTipTextByStatus['0']
})

const statusText = computed(() => {
  // 状态 0 未上传 1 审核中 2 已上传 3 审核不通过
  return statusTextByStatus[String(props.status)]
})
const isCanUpload = computed(() => {
  return canUploadStatus.indexOf(props.status) !== -1
  // return (
  //   canUploadStatus.indexOf(props.status) !== -1 &&
  //   props.userCardList.some((item) => item.active === 1)
  // )
})
const isNotUpload = computed(() => {
  return props.status === 0
})

const isReview = computed(() => {
  return props.status === 1
})

const isNotPass = computed(() => {
  return props.status === 3
})

const isPass = computed(() => {
  return props.status === 2
})

const statusClass = computed(() => {
  return {
    'not-upload': isNotUpload.value,
    review: isReview.value,
    'no-pass': isNotPass.value,
    'is-pass': isPass.value,
  }
})

const jumpHandle = () => {
  emit('upload')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "photo",
          style: _normalizeStyle({ backgroundImage: `url(${__props.photo})` })
        }, [
          (!__props.photo)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                width: "24",
                height: "24",
                src: _unref(user)
              }, null, 8, _hoisted_4))
            : _createCommentVNode("", true)
        ], 4),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(__props.name), 1),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", null, _toDisplayString(_unref(phoneText)), 1),
            _createElementVNode("div", {
              class: _normalizeClass(["status", _unref(statusClass)])
            }, _toDisplayString(_unref(statusText)), 3)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_unref(isCanUpload))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "jump-wrap",
              onClick: jumpHandle
            }, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(jumpTipText)), 1),
              _createElementVNode("img", {
                width: "16",
                height: "16",
                src: _unref(jumpIcon)
              }, null, 8, _hoisted_10)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_unref(isNotUpload) || _unref(isReview) || _unref(isNotPass))
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          (_unref(isNotUpload))
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("img", { src: _unref(warningIcon) }, null, 8, _hoisted_13),
                _hoisted_14
              ]))
            : _createCommentVNode("", true),
          (_unref(isReview))
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("img", { src: _unref(warningIcon) }, null, 8, _hoisted_16),
                _hoisted_17
              ]))
            : _createCommentVNode("", true),
          (_unref(isNotPass))
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("img", { src: _unref(noPassIcon) }, null, 8, _hoisted_19),
                _createElementVNode("div", null, _toDisplayString(__props.notPassReason), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})